import { graphql } from '../../../../graphql/generated';

export const PARAMETER_FORM_QUERY = graphql(`
  query ParameterForm($labId: ID!) {
    insurances {
      id
      shortName
    }

    labSpecialRates(labId: $labId) {
      id
      name
      shortName
      code
    }

    labDiagnoses(labId: $labId) {
      id
      name
    }

    labSpecimens(labId: $labId) {
      id
      name
      classification
      analysisStations {
        id
        name
      }
    }

    labAnalysisStations(labId: $labId) {
      id
      name
    }

    labForms(labId: $labId) {
      id
      name
    }

    labPeriodicGroups(labId: $labId) {
      id
      name
    }

    lab(id: $labId) {
      id
      pl1Name
      pl2Name
      pl3Name
      pl4Name
      pl5Name
    }
  }
`);
